import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import type { RiskItem } from "./DashboardMetrics";

interface SuccessionRisksOverlayProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  risks: RiskItem[];
  highCount: number;
  mediumCount: number;
}

export function SuccessionRisksOverlay({ open, onOpenChange, risks, highCount, mediumCount }: SuccessionRisksOverlayProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Succession Risks</DialogTitle>
        </DialogHeader>

        <div className="flex gap-3 mb-4">
          {highCount > 0 && (
            <Badge variant="destructive">{highCount} high priority</Badge>
          )}
          {mediumCount > 0 && (
            <Badge variant="outline" className="border-warning text-warning">{mediumCount} medium priority</Badge>
          )}
        </div>

        <div className="space-y-3">
          {risks.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-4">No risk details available.</p>
          ) : (
            risks.map((risk, i) => (
              <div key={risk.code || i} className="flex items-center gap-3 p-3 rounded-lg bg-muted/50">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{risk.name}</p>
                  <p className="text-xs text-muted-foreground">{risk.code}</p>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <div className="w-16">
                    <Progress
                      value={risk.score}
                      className={`h-1.5 ${risk.level === 'high' ? '[&>div]:bg-destructive' : '[&>div]:bg-warning'}`}
                    />
                  </div>
                  <span className={`text-sm font-semibold min-w-[3ch] text-right ${risk.level === 'high' ? 'text-destructive' : 'text-warning'}`}>
                    {Math.round(risk.score)}%
                  </span>
                  <Badge
                    variant={risk.level === 'high' ? 'destructive' : 'outline'}
                    className={`text-[10px] px-1.5 ${risk.level === 'medium' ? 'border-warning text-warning' : ''}`}
                  >
                    {risk.level === 'high' ? 'High' : 'Medium'}
                  </Badge>
                </div>
              </div>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
